const CITY_NAMES: Record<string, { en: string; ar: string }> = {
  baghdad:      { en: 'Baghdad',      ar: 'بغداد' },
  basra:        { en: 'Basra',        ar: 'البصرة' },
  erbil:        { en: 'Erbil',        ar: 'أربيل' },
  arbeel:       { en: 'Erbil',        ar: 'أربيل' },
  najaf:        { en: 'Najaf',        ar: 'النجف' },
  mosul:        { en: 'Mosul',        ar: 'الموصل' },
  karbala:      { en: 'Karbala',      ar: 'كربلاء' },
  kirkuk:       { en: 'Kirkuk',       ar: 'كركوك' },
  sulaymaniyah: { en: 'Sulaymaniyah', ar: 'السليمانية' },
  babel:        { en: 'Babylon',      ar: 'بابل' },
  babylon:      { en: 'Babylon',      ar: 'بابل' },
  duhok:        { en: 'Duhok',        ar: 'دهوك' },
  anbar:        { en: 'Anbar',        ar: 'الأنبار' },
  diyala:       { en: 'Diyala',       ar: 'ديالى' },
  wasit:        { en: 'Wasit',        ar: 'واسط' },
  maysan:       { en: 'Maysan',       ar: 'ميسان' },
  muthanna:     { en: 'Muthanna',     ar: 'المثنى' },
  diwaniyah:    { en: 'Diwaniyah',    ar: 'الديوانية' },
  'dhi qar':    { en: 'Dhi Qar',      ar: 'ذي قار' },
  salahaddin:   { en: 'Salah al-Din', ar: 'صلاح الدين' },
  halabja:      { en: 'Halabja',      ar: 'حلبجة' },
  // Prod city-code aliases (GET /lists/city-codes)
  zeeqar:       { en: 'Dhi Qar',      ar: 'ذي قار' },
  diwania:      { en: 'Diwaniyah',    ar: 'الديوانية' },
  simawa:       { en: 'Samawah',      ar: 'السماوة' },
  saladin:      { en: 'Salah al-Din', ar: 'صلاح الدين' },
  dihok:        { en: 'Duhok',        ar: 'دهوك' },
  solaimania:   { en: 'Sulaymaniyah', ar: 'السليمانية' },
  karkok:       { en: 'Kirkuk',       ar: 'كركوك' },
  koot:         { en: 'Kut',          ar: 'الكوت' },
};

export function cityLabel(
  slug: string | null | undefined,
  locale: 'en' | 'ar'
): string {
  if (!slug) return '';
  const key = slug.trim().toLowerCase().replace(/_/g, ' ');
  const entry = CITY_NAMES[key];
  if (entry) return entry[locale];
  return key.replace(/\b\w/g, (c) => c.toUpperCase());
}
